/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useHistory } from "react-router-dom";
import {
  Col,
  FlexContainer,
  Heading,
  Message,
  Row,
  Spacer,
} from "@nordcloud/gnui";
import { InfoCard } from "~/components";
import { ReactComponent as BrowserIcon } from "../../../assets/images/browser.svg";
import { ReactComponent as PlusIcon } from "../../../assets/images/plus.svg";

type Props = {
  applicationId?: string | null;
  clearHandler: () => void;
};

export function Summary({ applicationId, clearHandler }: Props) {
  const history = useHistory();
  return (
    <Row justify="center">
      <Col sm={8} md={6}>
        <Message status="success" image="success">
          Application has been added
        </Message>
        <Spacer height="1.5rem" />
        <FlexContainer justifyContent="space-between">
          <InfoCard
            align="center"
            onClick={() => {
              history.push(`/applications/${applicationId}`);
            }}
          >
            <BrowserIcon />
            <Heading marginTop="1rem" level={4}>
              Application Details
            </Heading>
          </InfoCard>
          <InfoCard
            align="center"
            onClick={() => {
              history.push(`/applications`);
            }}
          >
            <BrowserIcon />
            <Heading marginTop="1rem" level={4}>
              Applications List
            </Heading>
          </InfoCard>
          <InfoCard align="center" onClick={() => clearHandler()}>
            <PlusIcon />
            <Heading marginTop="1rem" level={4}>
              Add Another Application
            </Heading>
          </InfoCard>
        </FlexContainer>
      </Col>
    </Row>
  );
}
